import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const GrossSalesCustChart = ({ startPeriod, endPeriod, ctrtDsaSd }) => {
  const rsrc = useRsrc();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null); // reset so old chart doesn't flash while loading
    const reqParam = { startPeriod, endPeriod, ctrtDsaSd };
    rsrc.data('sc', 'GROSS_SALES_CUST_DATA_PLUGIN', reqParam)
      .then((resp) => { setData(resp); })
      .finally(() => { setLoading(false); });
  }, [startPeriod, endPeriod, rsrc]); // include rsrc to satisfy hooks rule

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography mt={2}>Loading...</Typography>
      </Box>
    );
  }

  if (!data) return null;

  const custs = Object.keys(data);
  if (!custs.length) return null;

  const periods = Object.keys(data[custs[0]] || {});

  const series = custs.map((cust) => ({
    label: cust,
    values: periods.map((p) => Number(data[cust]?.[p] ?? 0)),
    type: 'line',
  }));

  const chartData = {
    categories: periods,
    series: series,
  }
  return (
    <CartesianChart
      yLabel={'Sales Amount'}
      legend = {'top'}
      data = {chartData}
    />
  );
};
